
import WidgetDefaultNuxt from '../default/nuxt.vue';
import { loadJS } from '@/libs/async-load.js';
import defaultValues from '@xd-rocket/attributes/src/attributes/xdvideo/default';

export default {
  name: 'WidgetVideoCanvasNuxt',
  extends: WidgetDefaultNuxt,
  data() {
    const { loop, autoplay, progressive, canvasAlpha, webGL } =
      this.values.xdvideo || defaultValues.xdvideo;
    return {
      player: null,
      options: {
        loop,
        autoplay,
        progressive,
        canvasAlpha,
        webGL,
      },
      widgetClassName: 'widget-video-canvas',
      status: false,
      is_mobile: true,
    };
  },
  computed: {
    customClasses() {
      const { status } = this;
      return {
        ...this.classes,
        'rocket-video-canvas-playing': status,
      };
    },
    video() {
      const { getLocaleValue } = this;
      const { ld } = this.values.xdvideo || defaultValues.xdvideo;
      return getLocaleValue(ld);
    },
  },
  watch: {
    video: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          if (this.player) {
            this.player.destroy();
          }
          this.callback();
        }
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await loadJS('https://website.xdcdn.net/poster/.system/js/jsmpeg.min.js');
      if (window.JSMpeg && this.video) {
        this.callback();
        // const { CONSTANT } = window.moo;
        // this.is_mobile = CONSTANT.IS_MOBILE;
        // if (!CONSTANT.IS_MOBILE) return;
        // (() => {
        //   const n = document.createElement('script'),
        //     m = document.getElementsByTagName('script')[0];
        //   n.async = 1;
        //   n.src = 'https://website.xdcdn.net/poster/.system/js/jsmpeg.min.js';
        //   m.parentNode.insertBefore(n, m);
        //   const that = this;
        //   if (window.ActiveXObject || 'ActiveXObject' in window) {
        //     if (n.readyState) {
        //       n.onreadystatechange = function () {
        //         if (
        //           this.readyState == 'loaded' ||
        //           this.readyState === 'complete'
        //         ) {
        //           that.callback();
        //         }
        //       };
        //     } else {
        //       n.onload = function () {
        //         that.callback();
        //       };
        //     }
        //   } else {
        //     n.onload = function (e) {
        //       that.callback();
        //     };
        //   }
        // })();
      }
    },
    initEvent() {
      this.rocketOn('rocket:videoCanvas:play', true, () => {
        if (this.status) return;
        if (this.player) {
          this.play();
        }
      });
      this.rocketOn('rocket:videoCanvas:pause', true, () => {
        if (!this.status) return;
        if (this.player) {
          this.pause();
        }
      });
      this.rocketOn('rocket:videoCanvas:stop', true, () => {
        if (this.player) {
          this.stop();
        }
      });
    },
    callback() {
      this.player = new window.JSMpeg.Player(this.video, {
        canvas: this.$refs.videoCanvas,
        throttled: false, // 节流
        chunkSize: 1024 * 1024, // 默认1024*1024(1mb)
        progressive: this.options.progressive, // 分块加载
        audio: false,
        autoplay: this.options.autoplay,
        loop: this.options.loop,
        alpha: this.options.canvasAlpha,
        disableGl: !this.options.webGL,
        decodeFirstFrame: true,
        // fps: 15,
        onSourceProgress: (progress) => {
          let p = Math.round(progress * 100) + '%';
          this.rocketEmit('rocket:videoCanvas:progress', true, p);
        },
        onSourceCompleted: () => {
          this.rocketEmit('rocket:videoCanvas:loaded', true);
        },
        onPlay: () => {
          this.status = true;
          this.rocketEmit('rocket:videoCanvas:playing', true);
        },
        onPause: () => {
          this.status = false;
          this.rocketEmit('rocket:videoCanvas:paused', true);
        },
        onEnded: () => {
          this.status = false;
          this.rocketEmit('rocket:videoCanvas:ended', true);
        },
        onStalled: () => {
          this.player.pause();
        },
        onSourceEstablished: () => {
          this.$nextTick(() => {
            if (!this.player) return;

            let c = this.player.renderer;
            if (c.width && c.height) {
              let style = document.createElement('style');
              style.type = 'text/css';
              style.innerHTML = `
                @media screen and (max-aspect-ratio: ${c.width}/${c.height}) {
                  #${this.id} canvas {
                    width: auto;
                    height: 100%;
                    top: 0;
                    left: 50%;
                    transform: translate3d(-50%, 0, 0);
                  }
                }
                @media screen and (min-aspect-ratio: ${c.width}/${c.height}) {
                  #${this.id} canvas {
                    width: 100%;
                    height: auto;
                    top: 50%;
                    left: 0;
                    transform: translate3d(0, -50%, 0);
                  }
                }
              `;
              document.getElementsByTagName('head')[0].appendChild(style);
            }

            this.rocketEmit('rocket:videoCanvas:ready', true);
          });
        },
      });
      // 创建一个定时器,每秒清除一次Canvas内容
      // setInterval(() => {
      //   const context = canvas.getContext('2d');
      //   context.clearRect(0, 0, canvas.width, canvas.height);
      // }, 1000);
    },
    play() {
      if (!this.player) return;
      this.player.play();
    },
    pause() {
      if (!this.player) return;
      this.player.pause();
    },
    stop() {
      if (!this.player) return;
      this.player.stop();
    },
    getVolume() {
      if (!this.player) return;
      return this.player.volume;
    },
    setVolume(v) {
      if (!this.player) return;
      this.player.volume = v;
    },
    getCurrentTime() {
      if (!this.player) return;
      return this.player.currentTime;
    },
    setCurrentTime(t) {
      if (!this.player) return;
      this.player.currentTime = t;
    },
    getPaused() {
      if (!this.player) return;
      return this.player.paused;
    },
  },
};
